// Kontextové články z Academy uvnitř nástrojů (FÁZE 5).
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { GraduationCap } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContextArticles({ category, title = "Z Academy k tématu" }) {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        axios.get(`${API}/blog/posts`, { params: { category, limit: 3 } })
            .then((r) => setPosts((r.data.posts || []).slice(0, 3)))
            .catch(() => {});
    }, [category]);
    if (!posts.length) return null;
    return (
        <div className="border border-fa-cream/20 bg-fa-cream/5 p-4 mt-8" data-testid="context-articles">
            <div className="font-mono text-[9px] uppercase tracking-widest text-fa-cream flex items-center gap-1.5 mb-3">
                <GraduationCap size={12} /> {title}
            </div>
            <div className="grid sm:grid-cols-3 gap-2">
                {posts.map((p) => (
                    <Link key={p.slug} to={`/academy/${p.slug}`} data-testid={`context-article-${p.slug}`}
                          className="border border-white/10 bg-black/40 p-3 hover:border-fa-cream/50 transition-colors group">
                        <div className="font-display font-bold text-xs group-hover:text-fa-cream transition-colors line-clamp-2">{p.title}</div>
                        <div className="font-mono text-[8px] text-white/40 mt-1 line-clamp-2">{p.perex}</div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
